module.exports = __webpack_public_path__ + "img/5ac_22.95f9f9f1.gif";